declare global {
  interface Window{
    globalConfig: {
      REACT_APP_MAIN_DOMAIN: string,
      REACT_APP_DEFAULT_URL_API: string,

      REACT_APP_INSTRUMENTATION_KEY: string,
      REACT_APP_STRIPE_PUBLIC_KEY: string,
      REACT_APP_HELP_SITE_BASE: string,
      REACT_APP_NAMES_SIGN_UP_SIGN_IN_AUTHORITY: string,
      REACT_APP_NAMES_AUTHORITY_DOMAIN: string,

      REACT_APP_NAMES_CLIENT_URL: string,
      REACT_APP_SCOPE_URL: string
      REACT_APP_NON_PROFIT_REGISTER: string
      REACT_APP_TERMS: string
      REACT_APP_DISPLAY_STAGING_STATUS: string

      REACT_APP_PRODUCTION_PAGE: string
    }
  }
}
import { LogLevel } from '@azure/msal-browser'

const factoryProd = (): any => {
    // CIAM: authority https://{tenant}.ciamlogin.com/{tenant-id} — do not append /v2.0 (MSAL adds it).
    const identityAuthority = {
      authority: window.globalConfig.REACT_APP_NAMES_SIGN_UP_SIGN_IN_AUTHORITY!,
      authorityHost: window.globalConfig.REACT_APP_NAMES_AUTHORITY_DOMAIN!,
    }

    const msalConfig = {
      auth: {
        clientId: window.globalConfig.REACT_APP_NAMES_CLIENT_URL!,
        authority: identityAuthority.authority,
        knownAuthorities: [identityAuthority.authorityHost],
        redirectUri: '/',
        postLogoutRedirectUri: '/',
        // CIAM expects a stable redirect chain; false can break session correlation on the IdP.
        navigateToLoginRequestUrl: true,
      },
      cache: {
        cacheLocation: 'localStorage',
        // Helps when partitioned storage / privacy settings interfere with redirect + PKCE state.
        storeAuthStateInCookie: true,
      },
      system: {
        loggerOptions: {
          loggerCallback: (level: any, message: any, containsPii: any) => {
            if (containsPii) {
              return
            }
            switch (level) {
              case LogLevel.Error:
                console.error(message)
                return
              case LogLevel.Info:
                console.info(message)
                return
              case LogLevel.Verbose:
                console.debug(message)
                return
              case LogLevel.Warning:
                console.warn(message)
                return
              default:
                return
            }
          },
        },
      },
    }

    const msalRequest = {
      scopes: [window.globalConfig.REACT_APP_SCOPE_URL!],
    }

    const productionPage = window.globalConfig.REACT_APP_PRODUCTION_PAGE
    const stripePublicKey = window.globalConfig.REACT_APP_STRIPE_PUBLIC_KEY
    const instrumentationKey = window.globalConfig.REACT_APP_INSTRUMENTATION_KEY
    const configUrl = window.globalConfig.REACT_APP_DEFAULT_URL_API
    const nonProfitRegister = window.globalConfig.REACT_APP_NON_PROFIT_REGISTER
    const terms = window.globalConfig.REACT_APP_TERMS
    const help = window.globalConfig.REACT_APP_HELP_SITE_BASE

    return {
      productionPage,
      msalRequest,
      msalConfig,
      stripePublicKey,
      instrumentationKey,
      configUrl,
      nonProfitRegister,
      terms,
      help
    }
}

const factoryDev = ()=> {
  const identityAuthority = {
    authority: process.env.REACT_APP_NAMES_SIGN_UP_SIGN_IN_AUTHORITY!,
    authorityHost: process.env.REACT_APP_NAMES_AUTHORITY_DOMAIN!,
  }

  const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_NAMES_CLIENT_URL!,
      authority: identityAuthority.authority,
      knownAuthorities: [identityAuthority.authorityHost],
      redirectUri: '/',
      postLogoutRedirectUri: '/',
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: any, message: any, containsPii: any) => {
          if (containsPii) {
            return
          }
          switch (level) {
            case LogLevel.Error:
              process.env.NODE_ENV === 'development' && console.error(message)
              return
            case LogLevel.Info:
              process.env.NODE_ENV === 'development' && console.info(message)
              return
            case LogLevel.Verbose:
              process.env.NODE_ENV === 'development' && console.debug(message)
              return
            case LogLevel.Warning:
              process.env.NODE_ENV === 'development' && console.warn(message)
              return
            default:
              return
          }
        },
      },
    },
  }

  const msalRequest = {
    scopes: [process.env.REACT_APP_SCOPE_URL!],
  }

  const productionPage = window.globalConfig.REACT_APP_PRODUCTION_PAGE
  const stripePublicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY!
  const instrumentationKey = process.env.REACT_APP_INSTRUMENTATION_KEY
  const configUrl = process.env.REACT_APP_DEFAULT_URL_API
  const configDomain = process.env.REACT_APP_MAIN_DOMAIN
  const nonProfitRegister = window.globalConfig.REACT_APP_NON_PROFIT_REGISTER
  const terms = window.globalConfig.REACT_APP_TERMS
  const help = window.globalConfig.REACT_APP_HELP_SITE_BASE
  const stage = window.globalConfig.REACT_APP_DISPLAY_STAGING_STATUS

  return {
    productionPage,
    msalRequest,
    msalConfig,
    stripePublicKey,
    instrumentationKey,
    configUrl,
    configDomain,
    nonProfitRegister,
    terms,
    help,
    stage
  }
}

const {
  productionPage,
  msalRequest,
  msalConfig,
  stripePublicKey,
  instrumentationKey,
  configUrl,
  configDomain,
  nonProfitRegister,
  terms,
  help
} = (process.env && process.env.NODE_ENV !== 'development') ? factoryProd() : factoryDev()

export {
  productionPage,
  msalRequest,
  msalConfig,
  stripePublicKey,
  instrumentationKey,
  configDomain,
  configUrl,
  nonProfitRegister,
  terms,
  help
}
